import { render, staticRenderFns } from "./OwnershipAndManagement.vue?vue&type=template&id=514de638&"
import script from "./OwnershipAndManagement.vue?vue&type=script&lang=js&"
export * from "./OwnershipAndManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports